class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    if (this.dataset.loadWhenVisible === 'true' && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.visibilityObserver.disconnect();
        this.loadScripts();
      }, { rootMargin: '600px 0px' });
      this.visibilityObserver.observe(this.closest('.shopify-section') || this.parentElement);
      return;
    }

    this.loadScripts();
  }

  disconnectedCallback() {
    this.visibilityObserver?.disconnect();
  }

  loadScripts() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');
    const loadingKeys = window.wetheme.webcomponentRegistry.loadingKeys ||= new Set();

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded && !loadingKeys.has(key)) {
        loadingKeys.add(key);
        const postLoadedScript = document.createElement('script');
        const {defer, async, type} = script;
        const src = script.dataset.src || script.src;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;
        postLoadedScript.addEventListener('error', () => loadingKeys.delete(key), { once: true });


        this.parentElement.appendChild(postLoadedScript);

      }
    });

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);
